"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PrescriptionCreateRequestSchema () {
        return PrescriptionCreateRequestSchema;
    },
    get PrescriptionCreateResponseSchema () {
        return PrescriptionCreateResponseSchema;
    },
    get PrescriptionDiscardResponseSchema () {
        return PrescriptionDiscardResponseSchema;
    },
    get PrescriptionGamotReferenceRequestSchema () {
        return PrescriptionGamotReferenceRequestSchema;
    },
    get PrescriptionIssueRequestSchema () {
        return PrescriptionIssueRequestSchema;
    },
    get PrescriptionSaveRequestSchema () {
        return PrescriptionSaveRequestSchema;
    },
    get PrescriptionVoidRequestSchema () {
        return PrescriptionVoidRequestSchema;
    }
});
const _zod = require("zod");
const _prescriptionitem = require("./prescription-item");
const _prescriptionstatus = require("./prescription-status");
const _prescriptiontext = require("./prescription-text");
const PrescriptionCreateRequestSchema = _zod.z.object({
    encounterId: _zod.z.string({
        error: 'encounterId is required.'
    }).uuid()
}).strict();
const PrescriptionCreateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    resumed: _zod.z.boolean()
}).strict();
const PrescriptionSaveRequestSchema = _zod.z.object({
    version: (0, _prescriptiontext.versionField)(),
    branchId: _zod.z.string({
        error: 'branchId must be a clinic id or null.'
    }).uuid().nullable(),
    items: _zod.z.array(_prescriptionitem.PrescriptionItemInputSchema, {
        error: 'items must be a list.'
    }).max(_prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax, {
        error: `At most ${String(_prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax)} medicines per prescription.`
    })
}).strict();
const PrescriptionIssueRequestSchema = _zod.z.object({
    version: (0, _prescriptiontext.versionField)(),
    expectedAllergyRecordedAt: (0, _prescriptiontext.isoDateTime)().nullable(),
    acknowledgeUnknownAllergyStatus: _zod.z.boolean().default(false),
    acknowledgeNameOnlyLines: _zod.z.boolean().default(false)
}).strict();
const PrescriptionVoidRequestSchema = _zod.z.object({
    reasonCode: _prescriptionstatus.PrescriptionVoidReasonSchema,
    note: (0, _prescriptiontext.optionalLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.voidNote, 'Note')
}).strict();
const PrescriptionGamotReferenceRequestSchema = _zod.z.object({
    upsc: (0, _prescriptiontext.nullableLineText)(_prescriptionstatus.PRESCRIPTION_LIMITS.upsc, 'Gamot reference')
}).strict();
const PrescriptionDiscardResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid()
}).strict();
